import './index.scss';
import { ItfEcoPicture } from './type';

const EcoPicture: React.FC<ItfEcoPicture> = ({ className, webp, jpg, ...rest }) => {
    const alt = rest?.alt || rest?.['aria-label'] || 'EcoFlow Picture';

    const WEBP_PC = Array?.isArray(webp) && webp?.[0] ? webp?.[0] : undefined;
    const WEBP_LAP = Array?.isArray(webp) && webp?.length === 4 ? webp?.[1] : webp?.[0];
    const WEBP_PAD = Array?.isArray(webp) && webp?.length === 4 ? webp?.[2] : webp?.length === 3 ? webp?.[1] : webp?.[0];
    const WEBP_H5 = Array?.isArray(webp) && webp?.length === 4 ? webp?.[3] : webp?.length === 3 ? webp?.[2] : webp?.length === 2 ? webp?.[1] : webp?.[0];

    const JPG_PC = Array?.isArray(jpg) && jpg?.[0] ? jpg?.[0] : undefined;
    if (!JPG_PC) {
        return <></>;
    }
    const JPG_LAP = Array?.isArray(jpg) && jpg?.length === 4 ? jpg?.[1] : jpg?.[0];
    const JPG_PAD = Array?.isArray(jpg) && jpg?.length === 4 ? jpg?.[2] : jpg?.length === 3 ? jpg?.[1] : jpg?.[0];
    const JPG_H5 = Array?.isArray(jpg) && jpg?.length === 4 ? jpg?.[3] : jpg?.length === 3 ? jpg?.[2] : jpg?.length === 2 ? jpg?.[1] : jpg?.[0];

    return (
        <picture className={`eco-picture${className ? ` ${className}` : ''}`} aria-label={alt}>
            {WEBP_PC && (
                <>
                    <source media={`(min-width: 1441px)`} srcSet={WEBP_PC} type="image/webp" />
                    <source media={`(max-width: 1440px) and (min-width: 1025px)`} srcSet={WEBP_LAP} type="image/webp" />
                    <source media={`(max-width: 1024px) and (min-width: 768px)`} srcSet={WEBP_PAD} type="image/webp" />
                    <source media={`(max-width: 767px)`} srcSet={WEBP_H5} type="image/webp" />
                </>
            )}
            <source media={`(max-width: 1440px) and (min-width: 1025px)`} srcSet={JPG_LAP} />
            <source media={`(max-width: 1024px) and (min-width: 768px)`} srcSet={JPG_PAD} />
            <source media={`(max-width: 767px)`} srcSet={JPG_H5} />
            <img src={JPG_PC} alt={alt} aria-label={alt} width="100%" height="100%" {...rest} />
        </picture>
    );
};

export default EcoPicture;
